export * from './extrato-cobranca.component';
